<template>
  <v-row class="justify-end">
    <!-- Page Navigation -->
    <v-col
      v-if="showFilterBar"
      class="col-auto text-center"
    >
      <v-row>
        <v-col
          class="col-auto px-0 text-center"
          style="max-width: 120px;"
        >
          <!-- Shift Page Left -->
          <v-btn
            class="caption font-weight-medium"
            :color="currentPage === 1 ? 'grey' : 'primary'"
            icon
            small
            :disabled="currentPage === 1"
            @click="$emit('page-left')"
          >
            <font-awesome-icon
              :icon="['fas', 'angle-left']"
              size="sm"
            />
          </v-btn>
        </v-col>

        <v-col
          class="col-auto text-truncate"
          style="width: fit-content"
        >
          <span
            class="caption font-weight-medium coolgray--text"
            style="line-height: 30px;"
          >
            {{ rowsPerPageLabel }}
          </span>
        </v-col>

        <v-col
          class="col-auto px-0 text-center"
        >
          <!-- Shift Page Right -->
          <v-btn
            class="caption font-weight-medium"
            :color="currentPage === totalPages ? 'grey' : 'primary'"
            :disabled="currentPage === totalPages"
            icon
            small
            @click="$emit('page-right')"
          >
            <font-awesome-icon
              :icon="['fas', 'angle-right']"
              size="sm"
            />
          </v-btn>
        </v-col>
      </v-row>
    </v-col>

    <!-- Rows Per Page Selector -->
    <v-col
      v-if="showFilterBar"
      class="col-auto font-weight-medium"
    >
      <v-row>
        <v-col>
          <v-menu
            v-model="showMenu"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                color="primary"
                small
                outlined
                class="caption font-weight-medium"
                v-on="on"
              >
                <span>{{ itemsPerPage === -1 ? 'All Rows' : `${formatNumber(itemsPerPage)} Rows / Page` }}</span>

                <font-awesome-icon
                  :icon="['fas', 'chevron-down']"
                  class="ml-2"
                />
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="option in itemsPerPageOptions"
                :key="option.value"
                @click="$emit('update:items-per-page', option.value)"
              >
                <v-list-item-title>
                  {{ option.text }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import format from 'src/utils/format'

export default {
  name: 'TablePagination',
  props: {
    showFilterBar: {
      type: Boolean,
      default: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      required: true,
    },
    itemsPerPageOptions: {
      type: Array,
      required: true,
    },
    currentRowCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showMenu: false,
      format,
    }
  },
  computed: {
    currentRowsIndexLast() {
      const indexLastPossible = this.currentRowCount && (this.itemsPerPage * this.currentPage)
      return Math.min(indexLastPossible, this.currentRowCount)
    },
    currentRowsIndexFirst() {
      if (!this.currentRowCount) return 0
      return (this.currentPage - 1) * this.itemsPerPage + 1
    },
    rowsPerPageLabel() {
      const currentRowCount = this.currentRowCount && format.number(this.currentRowCount)
      const isAllRows = this.itemsPerPage === -1
      const lastRowOnPage = isAllRows ? currentRowCount : this.currentRowsIndexLast
      const firstRowOnPage = this.currentRowsIndexFirst

      return `Rows ${firstRowOnPage} - ${lastRowOnPage} of ${currentRowCount}`
    },
  },
  methods: {
    formatNumber(value) {
      return format.number(value)
    },
  },
}
</script>
